// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3V4Le","label":"Section_label__219pB","contentWrap":"Section_contentWrap__3Of4A","footer":"Section_footer__1b4BD","footerInner":"Section_footerInner__3WkJw"};